import { defineComponent as _defineComponent } from 'vue'
import { computed, unref } from 'vue';
  import FilterListRender from '@ve/components/filters/common/components/FilterListRender/FilterListRender.vue';
  import useFilterAttributesAnalytics from '@ve/components/filters/common/use/useFilterAttributesAnalytics';
  import FiltersListSection from '@ve/components/searchFilters/filterList/desktop/FiltersListSection.vue';
  import { type IHotel } from '@entities/hotel';
  import { beachTypeFilterMethods } from '../../lib/BeachTypeFilterMethods';
  import filterHotelByRestType from '../../lib/filterHotelByRestType';
  import useFilterHotelsModel from '../../lib/useFilterHotelsModel';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopBeachTypeFilter',
  props: {
    allHotels: null,
    filteredHotels: null,
    visibleCounter: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
      allHotels: IHotel[];
      filteredHotels: IHotel[];
      visibleCounter: boolean;
  }

  
  const { restTypeFilter, beachTypeFilter } = useFilterHotelsModel();

  const filteredHotelsByRestType = computed(() => props.allHotels.filter((hotel) => filterHotelByRestType(hotel, unref(restTypeFilter))));

  const visibleFilter = computed(() => beachTypeFilterMethods.isSomeHotelHasBeachType(unref(filteredHotelsByRestType)));


  const { toggleAttributeHandler } = useFilterAttributesAnalytics(beachTypeFilterMethods, { typeEvent: 'beachType', nameAnyEventEng: '', nameAnyEventRu: 'тип пляжа_Любой' });

return { __sfc: true,props, restTypeFilter, beachTypeFilter, filteredHotelsByRestType, visibleFilter, toggleAttributeHandler, FilterListRender, FiltersListSection, beachTypeFilterMethods }
}

})